'use strict';

function CompanySettingsCtrl(
  $scope,
  translations,
  $q
) {
   $scope.translations = translations;

   $scope.createQ = function(func) {
    var d = $q.defer();
    func(d.resolve.bind(d), d.reject.bind(d));
    return d.promise;
  };
}

CompanySettingsCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'settings',
      'settings.statuses',
      'settings.classes',
      'categories'
    ]);
  }]
};
module.exports = CompanySettingsCtrl;

angular.module('dokiv')
  .controller('CompanySettingsCtrl', [
  '$scope',
  'translations',
  '$q',
  CompanySettingsCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanySettingsCtrl.js
// module id = 316
// module chunks = 0